module.exports = __webpack_public_path__ + "img/bs.e701b162.png";